import { DirectoFormValues } from '../models/schema'
import { fromDirectoEventResponse, toDirectoEventUpdate } from '../models/mapper'
import { DirectoEvent } from '../models/types'
import { updateDirectoEventV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateDirectoEvent(id: number, transitOperationId: number, formValues: DirectoFormValues): Promise<DirectoEvent> {
  const response = await updateDirectoEventV2(id, toDirectoEventUpdate(transitOperationId, formValues))
  return fromDirectoEventResponse(response)
}
